import { t } from "@/i18n-js/instance";
import { usePlanPageVariant } from "@/react/hooks/usePlanPageVariant";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";
import { usePlans } from "../../RegularPlan/PlansContext";
import { SubmitButton } from "../../RegularPlan/SubmitButton";
import { BillingIntervalRadio } from "./BillingIntervalSelector/BillingIntervalRadio";
import { PlanPrice } from "./PlanInfo/PlanPrice";
import { PlanSavings } from "./PlanInfo/PlanSavings";
import { PlanTitle } from "./PlanInfo/PlanTitle";
import { PlanSummarySkeleton } from "./PlanSummarySkeleton";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

export const PlanSummary = () => {
  const { selectedPlan } = usePlans();
  const { isCompactLayout } = usePlanPageVariant();
  if (!selectedPlan) {
    return <PlanSummarySkeleton />;
  }

  return (
    <div
      className={classNames(
        "border-primary flex flex-col gap-y-5 rounded-2xl border p-6",
        isCompactLayout ? "w-[325px]" : "w-[375px]",
      )}
    >
      <Typography.LabelXl weight="semibold">
        {t([localeRoot, "title"])}
      </Typography.LabelXl>
      <BillingIntervalRadio />
      <div>
        <PlanTitle />
        <PlanPrice />
      </div>
      <PlanSavings />
      <SubmitButton plan={selectedPlan} />
    </div>
  );
};
